import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const invoiceApplicationInvoiceTypeEnum = createEnum({
    VAT_SPECIAL: ['vat_special', '增值税专用发票', 'blue'],
    VAT_ORDINARY: ['vat_ordinary', '增值税普通发票', 'default'],
});
export const INVOICE_APPLICATION_INVOICE_TYPES = enumValues(invoiceApplicationInvoiceTypeEnum);
export const INVOICE_APPLICATION_INVOICE_TYPE_LABEL_MAP = enumLabelMap(invoiceApplicationInvoiceTypeEnum);
export const invoiceApplicationContentTypeEnum = createEnum({
    SERVICE: ['service', '服务类', 'cyan'],
    VEHICLE: ['vehicle', '车辆类', 'geekblue'],
});
export const INVOICE_APPLICATION_CONTENT_TYPES = enumValues(invoiceApplicationContentTypeEnum);
export const INVOICE_APPLICATION_CONTENT_TYPE_LABEL_MAP = enumLabelMap(invoiceApplicationContentTypeEnum);
export const invoiceApplicationStatusEnum = createEnum({
    REVIEWING: ['reviewing', '审核中', 'processing'],
    INVOICING: ['invoicing', '开票中', 'warning'],
    ISSUED: ['issued', '已开票', 'success'],
    REJECTED: ['rejected', '开票拒绝', 'error'],
});
export const INVOICE_APPLICATION_STATUSES = enumValues(invoiceApplicationStatusEnum);
export const INVOICE_APPLICATION_STATUS_LABEL_MAP = enumLabelMap(invoiceApplicationStatusEnum);
//# sourceMappingURL=invoice-application.js.map